import Vue from "vue";
import VueRouter from "vue-router";
import Registration from "../views/Registration.vue";
import Login from "../views/Login.vue";
import CreateAccount from "../views/CreateAccount.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Success from "../views/Success.vue";
import ResetPassword from "../views/ResetPassword.vue";
import RegistrationSimple from "../views/RegistrationSimple.vue";
import VerifyAccount from "../views/VerifyAccount.vue";
import DeleteAccount from "../views/DeleteAccount.vue";
import Discord from "../views/Discord.vue";
import DeleteAccountFb from "../views/DeleteAccountFromFb.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/discord-oauth",
    name: "Discord",
    component: Discord
  },
  {
    path: "/",
    name: "Registration",
    component: Registration
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/registration-simple",
    name: "RegistrationSimple",
    component: RegistrationSimple
  },
  {
    path: "/createAccount",
    name: "CreateAccount",
    component: CreateAccount
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword
  },
  {
    path: "/success",
    name: "Success",
    component: Success
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword
  },
  {
    path: "/verify-account",
    name: "VerifyAccount",
    component: VerifyAccount
  },
  {
    path: "/delete-account",
    name: "DeleteAccount",
    component: DeleteAccount
  },
  {
    path: "/discord",
    name: "DiscordAuth",
    component: Discord
  },
  {
    path: "/status",
    name: "DeleteAccountFb",
    component: DeleteAccountFb
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes
});

export default router;
